import { reactive } from 'vue'

export const languageStore = reactive({
  currentLanguage: localStorage.getItem('language') || 'zh-Hant',

  languages: [
    { code: 'en', name: 'English', nameNative: 'English' },
    { code: 'zh-Hant', name: 'Traditional Chinese', nameNative: '繁體中文' },
    { code: 'zh-Hans', name: 'Simplified Chinese', nameNative: '简体中文' }
  ],

  setLanguage(lang) {
    this.currentLanguage = lang
    localStorage.setItem('language', lang)
  },

  getLanguageName(code) {
    const lang = this.languages.find(l => l.code === code)
    return lang ? lang.nameNative : code
  }
})
